<div class="data-entry-cell-container" [class.edit-mode]="isEditMode" [class.view-mode]="!isEditMode">
  <div *ngIf="isLoadingSchema" class="loading-message">
    Loading dataset schema...
  </div>

  <div *ngIf="!isLoadingSchema && !targetDatasetId" class="no-dataset-message">
    <mat-icon>info</mat-icon>
    <p>No dataset selected. Configure this cell to select a target dataset.</p>
  </div>

  <div *ngIf="!isLoadingSchema && targetDatasetId && fieldMappings.length === 0" class="no-fields-message">
    <mat-icon>warning</mat-icon>
    <p>No field mappings configured. Configure this cell to map dataset fields.</p>
  </div>

  <form *ngIf="!isLoadingSchema && targetDatasetId && fieldMappings.length > 0" class="data-entry-form" (ngSubmit)="onSubmit()">
    <div class="form-fields">
      <div *ngFor="let mapping of fieldMappings" class="form-field" [class.hidden-field]="!isFieldVisible(mapping)">
        <ng-container *ngIf="isFieldVisible(mapping)">
          <!-- Free input fields with reference data (dropdown) -->
          <mat-form-field appearance="outline" *ngIf="mapping.inputSource === 'free' && hasReferenceData(mapping)" class="field-input">
            <mat-label>{{ getFieldLabel(mapping) }}</mat-label>
            <mat-select
              [(ngModel)]="formValues[mapping.fieldName]"
              [name]="mapping.fieldName"
              [disabled]="isEditMode || isSubmitting"
              (ngModelChange)="onFieldValueChange(mapping.fieldName)">
              <mat-option [value]="null">-- Select --</mat-option>
              <mat-option *ngFor="let option of getDropdownOptions(mapping)" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Free input fields without reference data (text input) -->
          <mat-form-field appearance="outline" *ngIf="mapping.inputSource === 'free' && !hasReferenceData(mapping)" class="field-input">
            <mat-label>{{ getFieldLabel(mapping) }}</mat-label>
            <input
              matInput
              [(ngModel)]="formValues[mapping.fieldName]"
              [name]="mapping.fieldName"
              [placeholder]="getFieldPlaceholder(mapping)"
              [disabled]="isEditMode || isSubmitting"
              (ngModelChange)="onFieldValueChange(mapping.fieldName)">
          </mat-form-field>

          <!-- Static fields (read-only) -->
          <mat-form-field appearance="outline" *ngIf="mapping.inputSource === 'static'" class="field-input read-only-field">
            <mat-label>{{ getFieldLabel(mapping) }}</mat-label>
            <input
              matInput
              [value]="getFieldValue(mapping)"
              [name]="mapping.fieldName"
              readonly
              disabled>
            <mat-icon matSuffix class="field-icon" matTooltip="Static value">lock</mat-icon>
          </mat-form-field>

          <!-- Context fields (read-only) -->
          <mat-form-field appearance="outline" *ngIf="mapping.inputSource === 'context'" class="field-input read-only-field">
            <mat-label>{{ getFieldLabel(mapping) }}</mat-label>
            <input
              matInput
              [value]="getFieldValue(mapping)"
              [name]="mapping.fieldName"
              readonly
              disabled>
            <mat-icon matSuffix class="field-icon" matTooltip="From context: {{ mapping.contextObjectKey }}.{{ mapping.contextFieldName }}">link</mat-icon>
          </mat-form-field>

          <!-- Null fields (read-only, auto-generated on backend) -->
          <mat-form-field appearance="outline" *ngIf="mapping.inputSource === 'null'" class="field-input read-only-field null-field">
            <mat-label>{{ getFieldLabel(mapping) }}</mat-label>
            <input
              matInput
              [value]="getFieldValue(mapping)"
              [name]="mapping.fieldName"
              readonly
              disabled>
            <mat-icon matSuffix class="field-icon" matTooltip="Auto-generated on backend">auto_awesome</mat-icon>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="isEditMode || isSubmitting"
        class="submit-button">
        <mat-spinner *ngIf="isSubmitting" diameter="16" class="button-spinner"></mat-spinner>
        <span [class.processing-text]="isSubmitting">
          {{ isSubmitting ? 'Submitting...' : submitButtonText }}
        </span>
      </button>
    </div>
  </form>
</div>
